const TURN_USERNAME = '17272883b5fec9717dfa9400';
const TURN_CREDENTIALS = 'p7KzKTDFvdwfnHQJ';

export { TURN_USERNAME, TURN_CREDENTIALS };